import { Fragment, useState } from "react";
import {
    LiveDot,
    type LiveDotSize,
    type LiveDotVariant,
} from "@design-system/LiveDot/LiveDot";
import { OptionToggle, VariantGrid, VariantItem } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";

const liveDotSizes = ["md", "xs"] as const satisfies readonly LiveDotSize[];
const liveDotVariants = [
    "neutral",
    "accent",
] as const satisfies readonly LiveDotVariant[];

/** Design-system playground for the pulsing "happening now" dot. */
export const LiveDotPlayground = () => {
    const [size, setSize] = useState<LiveDotSize>("md");
    const [variant, setVariant] = useState<LiveDotVariant>("neutral");

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Size</h2>
                        <OptionToggle
                            options={liveDotSizes}
                            value={size}
                            onChange={setSize}
                        />
                    </section>
                    <section>
                        <h2>Variant</h2>
                        <OptionToggle
                            options={liveDotVariants}
                            value={variant}
                            onChange={setVariant}
                        />
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={`${size} · ${variant}`}
                output={JSON.stringify({ size, variant }, null, 2)}
                belowStage={
                    <VariantGrid title="Size × variant" columns="auto">
                        {liveDotSizes.map((itemSize) => (
                            <Fragment key={itemSize}>
                                {liveDotVariants.map((itemVariant) => (
                                    <VariantItem
                                        key={itemVariant}
                                        label={`${itemSize} · ${itemVariant}`}
                                    >
                                        <LiveDot
                                            size={itemSize}
                                            variant={itemVariant}
                                        />
                                    </VariantItem>
                                ))}
                            </Fragment>
                        ))}
                    </VariantGrid>
                }
            >
                <LiveDot size={size} variant={variant} label="Live" />
            </ShowcasePreview>
        </SandboxLayout>
    );
};
